// src/schemas/GlobalSchema.jsx
import React, { useMemo } from "react";
import { getPublicOrigin } from "utils/getPublicOrigin";

/**
 * Adds ONLY structured data not already covered by the static
 * Organization + WebSite JSON-LD in public/index.html.
 * See GlobalStructuredData.jsx (retired) for why Organization/WebSite
 * are not repeated here.
 */
export default function GlobalSchema() {
  const data = useMemo(() => {
    // getPublicOrigin() falls back to the real production domain when
    // running under react-snap's local prerender server, so the frozen
    // static output always references martleystrategy.com, never a
    // localhost URL — see src/utils/getPublicOrigin.js.
    const origin = getPublicOrigin();

    return {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "SiteNavigationElement",
          "name": [
            "Home", "About", "BrandKeeper", "Pricing", "Contact",
            "Privacy Policy", "Cookie Policy", "BrandKeeper Terms", "Sign Up"
          ],
          "url": [
            `${origin}/`,
            `${origin}/about`,
            `${origin}/brandkeeper`,
            `${origin}/brandkeeper/pricing`,
            `${origin}/contact-us`,
            `${origin}/privacy-policy`,
            `${origin}/cookie-policy`,
            `${origin}/brandkeeper/terms`,
            `${origin}/sign-up`
          ]
        }
      ]
    };
  }, []);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}